const downloadPopup = {
    label: "Download Popups",
    name: "download_popup",
    file: "site/data/popups.yaml",
    fields: [
        {
            label: "Download Popup Content",
            name: "popups",
            widget: "list",
            fields: [
                {
                    label: "Name",
                    name: "name",
                    widget: "string",
                },
                {
                    label: "Title",
                    name: "title",
                    widget: "string",
                    required: false
                },
                {
                    label: "Content",
                    name: "content",
                    widget: "markdown",
                    required: false
                },
                {
                    label: "Content Type",
                    name: "value",
                    widget: "string"
                }
            ]
        }
    ]
}

export default downloadPopup;